import { render } from "./MarkdownField.vue?vue&type=template&id=0a5908b3"
import script from "./MarkdownField.vue?vue&type=script&lang=js"
export * from "./MarkdownField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MarkdownField.vue"]])

export default __exports__